import styles from './modal-components.module.css';
import { ModalHeaderProps } from './types';

export const ModalHeader = ({ children, variant = 'solid' }: ModalHeaderProps) => (
  <div className={styles.headerWrapper} data-variant={variant}>
    {children}
  </div>
);
